import { render, staticRenderFns } from "./MappingEdit.vue?vue&type=template&id=04b0fc2b"
import script from "./MappingEdit.vue?vue&type=script&lang=js"
export * from "./MappingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports